/**
 * LegendDot component barrel export
 *
 * View-only component for chart legend dots.
 */

export { default } from "./LegendDotView";
